/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Zpět do košíku`
};

const da_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Tilbage til kurven`
};

const de_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Zurück zum Warenkorb`
};

const en_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Go back to cart`
};

const es_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Volver al carrito`
};

const fr_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Retourner au panier`
};

const hu_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Vissza a kosárhoz`
};

const it_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Torna al carrello`
};

const nl_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Terug naar winkelwagen`
};

const pl_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Wróć do koszyka`
};

const pt_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Voltar ao carrinho`
};

const sv_checkout_fail_button = /** @type {(inputs: {}) => string} */ () => {
	return `Tillbaka till kundvagnen`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const checkout_fail_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.checkout_fail_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("checkout_fail_button", locale)
	if (locale === "cs") return cs_checkout_fail_button(inputs)
	if (locale === "da") return da_checkout_fail_button(inputs)
	if (locale === "de") return de_checkout_fail_button(inputs)
	if (locale === "en") return en_checkout_fail_button(inputs)
	if (locale === "es") return es_checkout_fail_button(inputs)
	if (locale === "fr") return fr_checkout_fail_button(inputs)
	if (locale === "hu") return hu_checkout_fail_button(inputs)
	if (locale === "it") return it_checkout_fail_button(inputs)
	if (locale === "nl") return nl_checkout_fail_button(inputs)
	if (locale === "pl") return pl_checkout_fail_button(inputs)
	if (locale === "pt") return pt_checkout_fail_button(inputs)
	return sv_checkout_fail_button(inputs)
};
export { checkout_fail_button as "checkout.fail_button" }